export default {
  props: {
    dimensionIcon: {
      required: true,
    }
  },

  methods: {
    toggle () {
      this.$store.dispatch('slideShow/toggleSlideShow')
    },

    next () {
      this.$store.dispatch('slideShow/nextArtwork')
    },

    previous () {
      this.$store.dispatch('slideShow/previousArtwork')
    },
  },

  computed: {
    hasNext () {
      return this.$store.getters['slideShow/hasNext']
    },

    hasPrevious () {
      return this.$store.getters['slideShow/hasPrevious']
    },

    artwork () {
      return this.$store.getters['slideShow/selectedArtwork']
    },

    artworkStatus () {
      if (this.artwork.status === 'Available') {
        return 'available'
      }

      if (this.artwork.status === 'Sold') {
        return 'sold'
      }

      if (this.artwork.status === 'reserved') {
        return 'reserved'
      }

      if (this.artwork.in_cart) {
        return 'in-cart'
      }
    }
  }
}
